/**
 * The words of DateField's month/year calendar (issue 783). The library has no
 * i18n of its own (ADR 0014), so the host passes them — or registers them once
 * for the whole app (`configureDateFields`, issue 823) — and having them is what
 * turns the calendar on.
 */
export interface DateFieldJumpLabels {
  /** The calendar button's accessible name, and the popover's. */
  open: string;
  previousMonth: string;
  nextMonth: string;
  month: string;
  year: string;
  /** The popover's "no date" action. */
  clear: string;
}

/**
 * The words that make a DateField more than a typed box (issue 823): the calendar's
 * labels, plus the letters of the typing hint ("TT.MM.JJJJ") in the reader's language.
 */
export interface DateFieldLabels extends DateFieldJumpLabels {
  /** The placeholder's day / month / year letters, e.g. `TT` `MM` `JJJJ`. */
  dayToken?: string;
  monthToken?: string;
  yearToken?: string;
}

/**
 * What every DateField of an app falls back to when the host passes nothing (issue 823):
 * the app's formatting locale and its words, both read on every render so a language
 * switch follows. The app registers it once at boot (app-kit's `registerAppKitI18n`
 * does); the library itself still imports no i18n (ADR 0014).
 */
export interface DateFieldDefaults {
  locale(): string;
  labels(): DateFieldLabels;
}

let defaults: DateFieldDefaults | null = null;

export function configureDateFields(next: DateFieldDefaults | null): void {
  defaults = next;
}

export function dateFieldDefaults(): DateFieldDefaults | null {
  return defaults;
}

export * from './dateTyping';
